// extracted by mini-css-extract-plugin
export default {"page":"EducationPage_page__i+G3W"};